
import React from "react";
import { Dropdown } from "@fluentui/react-northstar";
const Regions = (props) => {
    const inputItems = [
        'EU',
        'AMER',
        'APAC'
        
      ];
    return (
        <>
            <Dropdown
                className="child-title-call-flow"
                disabled = {!props.isNewCallFlow}
                items={inputItems}
                placeholder="Region"
                checkable
                defaultValue={props.region}
                value={props.region}
                onChange={props.getData}
                getA11ySelectionMessage={{
          onAdd: (item) => `${item} has been selected.`,
        }}
            />
        </>
    );
};
export default Regions;
